import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Pagination from "react-js-pagination";

import Table from "../common/Table";
import Navbar from "../layout/Navbar";
import Sidebar from "../layout/Sidebar";
import Spinner from "../common/Spinner";
import CreateEditAdminModal from "../modals/CreateEditAdminModal";
import { getAdmins, createAdmin } from "../../actions/adminActions";

import { adminLabels } from "../../constants/tableData";
import { ITEMS_PER_PAGE, admin_template } from "../../constants";

class Admins extends Component {
  state = {
    isOpen: true,
    activePage: 1,
    createAdminModal: false
  };

  componentDidMount() {
    this.props.getAdmins();
  }

  changePage = activePage => {
    this.setState({ activePage });
  };

  toggleSidebar = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  openCreateAdminModal = () => {
    this.setState({ createAdminModal: true });
  };

  closeCreateAdminModal = () => {
    this.setState({ createAdminModal: false });
  };

  createAdmin = data => {
    this.props.createAdmin(data);

    this.setState({ createAdminModal: false });
  };

  render() {
    const { isOpen, activePage, createAdminModal } = this.state;
    const { admins, loading } = this.props.admins;

    let sidebar = isOpen ? (
      <Sidebar isOpen={isOpen} toggleSidebar={this.toggleSidebar} />
    ) : (
      <i
        className="fas fa-bars"
        style={{ marginLeft: "10px", cursor: "pointer" }}
        onClick={this.toggleSidebar}
        title="Show"
      />
    );

    return (
      <div className="admins">
        <Navbar />
        {sidebar}

        <div className="container-fluid fixed-right">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="display-4 text-center">Admins</h1>
              <hr />
              <button
                className="btn btn-info"
                onClick={this.openCreateAdminModal}
                style={{ marginBottom: "5px" }}
              >
                Add Admin
              </button>
              {loading || admins === null ? (
                <Spinner />
              ) : (
                <React.Fragment>
                  <Table
                    labels={adminLabels}
                    data={admins.slice(
                      (activePage - 1) * ITEMS_PER_PAGE,
                      activePage * ITEMS_PER_PAGE
                    )}
                  />
                  <Pagination
                    activePage={activePage}
                    totalItemsCount={admins.length}
                    onChange={this.changePage}
                    pageRangeDisplayed={5}
                    itemsCountPerPage={ITEMS_PER_PAGE}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                </React.Fragment>
              )}
              {createAdminModal && (
                <CreateEditAdminModal
                  edit={false}
                  data={admin_template}
                  isOpen={createAdminModal}
                  closeModal={this.closeCreateAdminModal}
                  createEditAdmin={this.createAdmin}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Admins.propTypes = {
  createAdmin: PropTypes.func.isRequired,
  getAdmins: PropTypes.func.isRequired,
  admins: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  admins: state.admins,
  errors: state.errors
});

export default connect(mapStateToProps, { getAdmins, createAdmin })(Admins);
